"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSetNotification;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSetNotification() {
  return (0, _useWebChatAPIContext.default)().setNotification;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTZXROb3RpZmljYXRpb24udHMiXSwibmFtZXMiOlsidXNlU2V0Tm90aWZpY2F0aW9uIiwic2V0Tm90aWZpY2F0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7Ozs7QUFFZSxTQUFTQSxrQkFBVCxHQUFvRTtBQUNqRixTQUFPLHFDQUF1QkMsZUFBOUI7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IE5vdGlmaWNhdGlvbiBmcm9tICcuLi90eXBlcy9Ob3RpZmljYXRpb24nO1xuaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTZXROb3RpZmljYXRpb24oKTogKG5vdGlmaWNhdGlvbjogTm90aWZpY2F0aW9uKSA9PiB2b2lkIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkuc2V0Tm90aWZpY2F0aW9uO1xufVxuIl19